import styled from "styled-components";
import Card from "../../components/Card";
import "./dashboard.css";
import { Avatar, Button, Empty, List, Popover, Progress, Statistic, Table, Typography } from "antd";
import Title from "antd/es/typography/Title";
import { Link, useNavigate } from "react-router-dom";
import { EnvironmentFilled, SmileFilled } from "@ant-design/icons";
import { useContext, useEffect, useState } from "react";
import moment from "moment";
import { AuthService } from "../../services/AuthService";
import { sumStoreStock } from "../../helpers";
import StoreContext, { CartItem } from "../../context/storeContext";
import { UserContext } from "../../context/userContext";
import { Products } from "../../models/product";

const { Text } = Typography
const DashboardCard = styled.div`
padding: 2rem 2rem;
background: white;
border-radius: 5px;
filter: drop-shadow(0px 8px 24px rgba(151, 195, 255, 0.08));

`

const DashboardCardIcon = styled.div`
    width: 50px;
    height: 50px;
    border-radius: 35px;
    background-color: lightgreen;
    margin-right: 20px;
`

const promotionColumns = [
    {
        title: 'Titulli',
        dataIndex: 'title',
        key: 'barcode',
    },
    {
        title: 'Valide',
        dataIndex: 'endDate',
        key: 'endDate',
    },
]
const Dashboard = () => {

    const { user } = useContext(UserContext)
    const { cart, emptyCart } = useContext(StoreContext)
    const navigate = useNavigate();
    const [lowStockProducts, setLowStockProducts] = useState<Products>([]);
    const [discountedProducts, setDiscountProducts] = useState<Products>([]);
    const [orders, setOrders] = useState([]);
    const [promotions, setPromotions] = useState([]);
    const [users, setUsers] = useState([]);

    const getOrders = async () => {
        let res = await AuthService.getAllOrders({});
        console.log("get all orders", res);
        if (res && res.length > 0) {
            setOrders(res);
        }
    }

    const getAllUsers = async () => {
      
        let res = await AuthService.getAllUsers({});
        if (res) {
           
            setUsers(res);
        }
        console.log("get all users", res);
      
    }

    const getLowStockProducts = async () => {
        // setLoading(true);
        let res = await AuthService.getLowStockProducts({});
        console.log("get products", res);
        if (res) {
            // let discounted = res.filter(product => product?.discountedPrice < product?.price).sort((a, b) => a.discountedPrice - b.discountedPrice);
            setLowStockProducts(res);
        }
    };


    const getPromotions = async () => {
        try{
            let res = await AuthService.getPromotions({});
            console.log("prom res", res)
           
            
            if (res !== "undefined" && res && res?.length > 0) {
                alert("hyri ketu")
              let today = moment(); // Get today's date
          
              let filteredPromotions = res.filter(el => {
                let startDate = moment(el?.startDate);
                let endDate = moment(el?.endDate);
                
                // Check if today is between the start and end dates
                return today.isBetween(startDate, endDate, 'days', '[]');
              });
          
              let formatted = filteredPromotions.map(el => {
                let upEl = { ...el };
                upEl.startDate = moment(upEl?.startDate).format("DD.MM.YYYY");
                upEl.endDate = moment(upEl?.endDate).format("DD.MM.YYYY");
                upEl.products = upEl.promotionItems.length;
                return upEl;
              });
          
              setPromotions(formatted);
            } else {
              setPromotions([]);
            }
        }
        catch(Error ){
            console.log("Error fetching")
        }
       
      };
      
    const getDiscountedProducts = async () => {
        // setLoading(true);
        let res = await AuthService.getDiscountedProducts({});
        console.log("get discounted products", res);
        if (res) {
            let discounted = res
                .filter(product => product?.discountedPrice <= product?.price)
                .sort((a, b) => {
                    // Calculate discount percentage for each product
                    const discountA = parseFloat((((a?.price - a?.discountedPrice) / a?.price) * 100).toFixed(1));
                    const discountB = parseFloat((((b?.price - b?.discountedPrice) / b?.price) * 100).toFixed(1));

                    // Sort in descending order (higher discount comes first)
                    return discountB - discountA;
                });
            setDiscountProducts(discounted);
        }
    };


    const totalSum = orders.filter(order => order.status == 3).reduce((accumulator, order) => {
        return accumulator + order.totalAmount;
    }, 0);

    const DELIVERED_ORDERS = orders?.filter(el => el.status == 3)?.length;

    useEffect(() => {
        if (user?.details?.roleName == "Admin" || user?.details?.roleName == "Manager") {
            getOrders();
            getLowStockProducts();
            getAllUsers();
        }

        getDiscountedProducts();
        // getPromotions();
     
        // alert(user?.details.roleName)

    }, [])

    return (

        <>
            <div className="container">

                <div className="row">


                    {(user?.details?.roleName == "Admin" || user?.details?.roleName == "Manager") && (
                        <div className="col-lg-8 col-md-12">
                            <DashboardCard style={{ backgroundColor: "white", height: "100%" }}>
                                <Title level={3}>Përshëndetje, {user?.user?.fullName}✋</Title>

                                <ul className="d-flex mt-1" style={{ gap: 20 }}>
                                    <li style={{ color: "#C4C4C4" }}><SmileFilled /><span className="mx-1">{user?.details?.roleName}</span></li>
                                    {user?.details?.assignedStore
                                        && <li style={{ color: "#C4C4C4" }}><EnvironmentFilled /><span className="mx-1">{user?.details?.assignedStore
                                        }</span></li>}
                                </ul>

                                <div className="row mt-5">
                                    <div className="col-lg-4">
                                        <div className="ant-statistic" style={{ borderRightWidth: 1, borderColor: "#e5e3e3", borderStyle: "dotted", paddingRight: "1.5rem" }}>
                                            <p className="ant-statistic-title" style={{ fontSize: 14 }}>Porosi të përfunduara ({DELIVERED_ORDERS}/{orders?.length})</p>
                                            <Progress steps={5} percent={+((DELIVERED_ORDERS / orders?.length) * 100).toFixed(2)} size={20} className="mt-3" />
                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-md-4 col-sm-12 mt-lg-0 mt-md-2">
                                        <div className="px-lg-1 px-0" style={{ borderRightWidth: 1, borderColor: "#e5e3e3", borderStyle: "dotted" }}>

                                            <Statistic title="Bilanci" value={`€${totalSum}`} />
                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-md-4 col-sm-12">
                                        <div className="px-lg-1 px-0" style={{ borderRightWidth: 1, borderColor: "#e5e3e3", borderStyle: "dotted" }}>
                                            <Statistic title="Produkte" value={discountedProducts?.length} />
                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-md-4 col-sm-12">
                                        <div className="px-lg-1 px-0">
                                            <Statistic title="Përdorues" value={users?.length} />
                                        </div>
                                    </div>
                                </div>

                            </DashboardCard>
                        </div>
                    )}
                    {/* <div className="col-lg-4 col-md-12  mt-lg-0 mt-3">
                        <Card title="Promocione" style={{ height: "100%" }}>
                        
                        {promotions && <Table dataSource={promotions}  pagination={false} size="small" columns={promotionColumns} rowKey={"productId"} style={{ width: "100%" }} onRow={(record) => ({
                onClick: () => {
                    navigate("/promotion", { state: { promotion: record } });
                },
            })}  />}
                        </Card>

                    </div> */}
                  
                    <div className="col-lg-6 col-md-12  mt-lg-3 mt-3">
                        <Card title="Produktet në zbritje">
                            <List
                                pagination={{
                                    position: "bottom", align: "start", onChange: (page) => {
                                        console.log(page);
                                    },
                                    pageSize: 4
                                }}
                                dataSource={discountedProducts}
                                renderItem={(item, index) => (
                                    <List.Item>
                                        <List.Item.Meta
                                            avatar={
                                                <Avatar style={{ backgroundColor: "orange", verticalAlign: 'middle', textTransform: "uppercase" }} size="large" >
                                                    {/* {item?.name?.charAt(0)} */}
                                                    {(((item?.price - item?.discountedPrice) / item?.price) * 100).toFixed(1)}%
                                                </Avatar>
                                            }
                                            title={<Link to={"/articles"}>{item?.description}</Link>}
                                            description={`${item?.price} EUR → ${item?.discountedPrice} EUR`}
                                        />
                                    </List.Item>
                                )}
                            />
                        </Card>
                    </div>
                    {(user?.details?.roleName == "Admin" || user?.details?.roleName == "Manager") && (


                        <div className="col-lg-6 col-md-12 mt-lg-3 mt-3">
                            <Card title="Stoku i ulet">
                                <List
                                    pagination={{
                                        position: "bottom", align: "start", onChange: (page) => {
                                            console.log(page);
                                        },
                                        pageSize: 4
                                    }}
                                    dataSource={lowStockProducts}
                                    renderItem={(item, index) => (
                                        <List.Item>
                                            <List.Item.Meta
                                                avatar={
                                                    <Avatar style={{ backgroundColor: "red", verticalAlign: 'middle', textTransform: "uppercase" }} size="large" >
                                                        {/* {item?.name?.charAt(0)} */}
                                                        {/* {sumStoreStock(item)} */}
                                                    </Avatar>
                                                }
                                                title={<Link to={"/articles"}>{item?.description}</Link>}
                                                description={<p>{item?.storeStocks && Object.keys(item?.storeStocks).map(store => (<span style={{ marginRight: 10 }}>{store} {item?.storeStocks[store]}</span>))}</p>}
                                            />
                                        </List.Item>
                                    )}
                                />
                            </Card>
                        </div>
                    )}


                </div>
            </div>
        </>
    )
}

export default Dashboard;

export const PoweredDetails = () => {
    return (
        <>
            <p>Delvin Krasniqi</p>
            <a href="mailto:delvinn.k@gmail.com">delvinn.k@gmail.com</a>
            <a href="tel: +38349318505">+383 49 318 505</a>
        </>
    )
}